import { MarkupBaseItem } from '../markup-items/markup.base.item';
import { MarkupTextBoxItem } from '../markup-items/markup.textbox.item';
import { MarkupBaseOperator } from './markup.base.operator';
export class MarkupTextBoxOperator extends MarkupBaseOperator {

    public constructor(viewer: Communicator.WebViewer) {
        super(viewer);
    }

    public createMarkupItem(position: Communicator.Point2): void {
        const view = this._viewer.view;
        const cameraPoint = view.getCamera().getCameraPlaneIntersectionPoint(position, view);
        this._markupItem = new MarkupTextBoxItem(this._viewer);
        this._markupItem.setLineFormat(
            this._lineColor,
            this._lineWeight,
            this._lineOpacity,
            this._fillColor,
            this._fillColorOption);
        this._markupItem.setTextFormat(
            this._textFontSize,
            this._textColor,
            this._textFontFamily,
            this._textIsBold,
            this._textIsItalic,
            this._textIsUnderline);
        const itemId = this._viewer.markupManager.registerMarkup(this._markupItem);
        this._markupItem.setMarkupItemId(itemId);
        if (cameraPoint !== null) {
            (this._markupItem as MarkupTextBoxItem).setPoint1(cameraPoint);
            (this._markupItem as MarkupTextBoxItem).setPoint2(cameraPoint);
        }
    }
    public updateMarkupItem(position: Communicator.Point2): void {
        if (this._markupItem) {
            const view = this._viewer.view;
            const cameraPoint = view.getCamera().getCameraPlaneIntersectionPoint(position, view);
            if (cameraPoint !== null) {
                (this._markupItem as MarkupTextBoxItem).setPoint2(cameraPoint);
            }
            this._viewer.markupManager.refreshMarkup();
        }
    }

    setMoveGripPointItem(item: MarkupBaseItem): void {
        this._markupItem = item;
        this._markupItem.setMoveGripPointMode(true);
        this._markupItem.setJiggingMode(true);
        this._moveGripPointMode = true;
    }
}

